import React from 'react';

export interface RedirectProps {
  url?: string;
}

export const BrowserRedirect: React.FC<RedirectProps> = ({ url }) => {
  const isClient = !!window;

  if (isClient && url) {
    window.location.replace(url);
  }

  return null;
};
